export enum EmployeeStatusEnum {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE"
}